import {
  SET_CURRENT_USER,
  SET_USERS,
  SET_All_USERS_INACTIVE,
  SET_FETCH_ACTIVE_USERS_ERROR,
} from "../constants/actionTypes";

const initialState = {
  currentUser: null,
  users: [],
  allUsersInactive: false,
  fetchActiveUsersError: false,
};

function users(state = initialState, action) {
  switch (action.type) {
    case SET_All_USERS_INACTIVE:
      return {
        ...state,
        allUsersInactive: action.allUsersInactive,
      };

    case SET_FETCH_ACTIVE_USERS_ERROR:
      return {
        ...state,
        fetchActiveUsersError: action.fetchActiveUsersError,
      };

    case SET_CURRENT_USER:
      const settingsConfig = window.Social.getSettingsConfig();

      let currentUser = action.currentUser;
      if (
        settingsConfig.userSimulation &&
        currentUser[settingsConfig.userSimulationPath[0]]
      ) {
        currentUser.login = currentUser[settingsConfig.userSimulationPath[0]];

        for (let i = 1; i < settingsConfig.userSimulationPath.length; i++) {
          currentUser.login =
            currentUser.login[settingsConfig.userSimulationPath[i]];
        }
      }

      return {
        ...state,
        currentUser: action.currentUser,
      };

    case SET_USERS:
      return {
        ...state,
        users: action.users,
      };

    default:
      return state;
  }
}

export default users;
